export default __webpack_public_path__ + "static/media/01Djien60s.832ed377.mp3";